import {ChangeDetectorRef, Component, OnInit, OnDestroy} from '@angular/core'
import {FormBuilder, FormGroup, Validators} from '@angular/forms'
import {ActivatedRoute, Router} from '@angular/router'
import {Subject} from 'rxjs'
import {AuthService} from '@app/core/services/rest-api'
import {takeUntil, finalize} from 'rxjs/operators'

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styles: ['.small-text {margin-top: 5px; line-height: 1.2; display: block;}'],
  standalone: false,
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  isPasswordHidden = true

  showRedirectMessage = false

  form: FormGroup
  loading = false

  constructor(
    private authSvc: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.form = this.fb.group({
      code: this.fb.control(null, Validators.required),
      password: this.fb.control(null, Validators.required),
    })
    this.route.params.pipe(takeUntil(this.end$)).subscribe((params) => {
      if (params['code'] !== undefined) {
        this.form.get('code').setValue(params['code'])
        this.form.get('code').disable()
      }
    })
    this.route.queryParams.pipe(takeUntil(this.end$)).subscribe((params) => {
      if (params['src'] && params['src'] === 'forgot') {
        this.showRedirectMessage = true
      } else {
        this.showRedirectMessage = false
      }
    })
  }

  private end$: Subject<void> = new Subject<void>()
  ngOnDestroy() {
    this.end$.next()
    this.end$.complete()
  }

  submit() {
    /* Note getRawValue is needed else disabled controls not included */
    const values = this.form.getRawValue()

    this.loading = true
    this.authSvc
      .putPasswordReset(values.code, values.password)
      .pipe(
        finalize(() => {
          this.loading = false
          // Zoneless: schedule CD so a failed reset shows its error (and the
          // spinner clears) without needing another interaction.
          this.cdr.markForCheck()
        }),
      )
      .subscribe(
        () => {
          this.router.navigate(['login'])
        },
        (err) => {
          let errMsg = 'An error occurred'
          if (err.error) {
            if (err.error && err.error.description) {
              errMsg += ': ' + err.error.description
            } else {
              errMsg =
                'The MyPayter Portal is currently unavailable. Please try again later or contact your account manager.'
            }
          } else if (err.status !== 400) {
            errMsg =
              'The MyPayter Portal is currently unavailable. Please try again later or contact your account manager.'
          }
          this.form.setErrors({global: errMsg})
        },
      )
  }

  togglePasswordHideShow() {
    this.isPasswordHidden = !this.isPasswordHidden
  }

  showFieldInvalid(name: string) {
    const field = this.form.get(name)
    return field.touched && field.invalid
  }
}
